import { Box, Typography, useTheme } from "@mui/material";
import ColorPicker from "@/components/ColorPicker";
import UIPopper from "@/components/popover";
import { useState } from "react";

const ColorPickerPopOver = ({ color, callback, clickNode }) => {
  const [currentColor, setCurrentColor] = useState(color);
  const handleColorChange = (cl, closePopOver) => {
    // closePopOver(null);
    setCurrentColor(cl);
  };

  const { palette } = useTheme();

  return (
    <UIPopper
      onClose={() => callback(currentColor)}
      paperStyles={{ p: 1 }}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      transformOrigin={{ vertical: "bottom", horizontal: "center" }}
      clickNode={clickNode}
    >
      {({ setAnchorEl }) => {
        return (
          <Box>
            <ColorPicker
              selectedColor={currentColor}
              handleChange={(e) => handleColorChange(e.hex, setAnchorEl)}
            />
          </Box>
        );
      }}
    </UIPopper>
  );
};

export default ColorPickerPopOver;
